import React from 'react';
import SongList from '../../components/SongList'

export const TriHouse = ({ match: {params: {content}} }) => {
  return <SongList />;
}
